export const actionTypes = {
    FetchKeywordsRelevancy: "[FetchKeywordsRelevancy] Action",
    UpdateResultsKeywordsRelevancy: "[UpdateResultsKeywordsRelevancy] Action",
};